// extracted by mini-css-extract-plugin
module.exports = {"textBox":"SingleTextBox_textBox__z8qdm","textBox__text":"SingleTextBox_textBox__text__8kXnv","textBox__title":"SingleTextBox_textBox__title__tHc2u"};